import { render, staticRenderFns } from "./overseasWelcome.vue?vue&type=template&id=b1968e9a&scoped=true&"
import script from "./overseasWelcome.vue?vue&type=script&lang=js&"
export * from "./overseasWelcome.vue?vue&type=script&lang=js&"
import style0 from "./overseasWelcome.vue?vue&type=style&index=0&id=b1968e9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1968e9a",
  null
  
)

export default component.exports